






import Vue from 'vue';
import { Component} from 'vue-property-decorator';
import ReportGroupIndividualChart from '@/components/report/ReportGroupIndividualChart.vue';
import ReportClientIndividualChart from '@/components/report/ReportClientIndividualChart.vue';

@Component({
  name: 'ReportChart',
  components: { ReportGroupIndividualChart, ReportClientIndividualChart }
})
export default class ReportChart extends Vue {
}
